module.exports = __webpack_public_path__ + "img/variations@2x.1ffef62.jpg";